import Footer from "../../components/containers/Footer";
import { WhiteSpace } from "../../components/supports";
import { PlayerTime } from "../PlayerTime";
import { BR5A_Track } from "../BR5A_Track";
import { useState, useEffect } from "react";
import { Image } from "../../components/supports";
import "./leaderboards.css";
import ContentButton from "../../components/buttons/ContentButton";
import DownloadWarningBox from "../../components/containers/DownloadWarningBox";

const BR5ALeaderboards = () =>{
    const [times, setTimes] = useState([]);
    const [metric, isMetric] = useState(true);
    const [warningBox, setWarningBox] = useState(false);
    let tracks = [BR5A_Track(110,"Sunshine City 1/2 🏙️"),BR5A_Track(112,"Snow Peak 1/2 ❄️"),BR5A_Track(114,"Desert Canyon 1/2 🏜️")]
    
    const getTimes = async () =>{
        try {
            const response = await fetch("https://autoworks-server.vercel.app/api/leaderboards/5a");
            const data = await response.json();
            setTimes(data);
        } catch (error) {
                console.error("Failed to fetch:", error.message);
            return null;
        }
    }

    const toggleBox = () =>{
        setWarningBox(!warningBox);
    }


    const setMetricSystem = () =>{
        isMetric(true);
    }
    const setImperialSystem = () =>{
        isMetric(false);
    }
    const convertToImperial = () =>{
        for(let i = 0; i < times.length; i++){
            //times[i].top_speed = times[i].top_speed / 0.621371;
        }
    }

    const convertSpecificToImperial = (value) =>{
            if(!metric){
                value = Math.round(value * 0.621371);
                 return value;
            }else{
                return value;
            }
    }

    let speedString = "km/h";
    if(!metric){
        speedString = "mph";
    }

    useEffect (() =>{
        getTimes();
    }, [times])

    return(
        <div id="main_wrapper">
        <header>
            <h1></h1>
            <nav>
            </nav>
        </header>

        <div id="main_container">
     
        <WhiteSpace height="50"/>

                
              
        </div>
        <div id="contents">
            <section>
            {warningBox && 
                <div>
                    <DownloadWarningBox>
                    ⚠
                    <br></br>
                    <div>This time has been flagged.</div>
                    <div>Reason: game files might be altered.</div>
                    <br></br>
                    <WhiteSpace height={50}/>
                    <ContentButton onClick={toggleBox} buttonText={"Close"}></ContentButton>

                    </DownloadWarningBox>
                    
                </div>
                }



                <article className="article-center header">
                <Image src="/images/br5alogo.png" height={220}></Image>
                    <div>🏆 Leaderboards 🏆</div>
                   
                </article>
                <article className="article-center">
                    <div>Challenge Series</div>
                   
                </article>
                <WhiteSpace height="50"/>
                <div className="article-center">
                ⚙️ Measurement:
           
                <ContentButton buttonText={"km/h"} onClick={setMetricSystem}></ContentButton>
                <ContentButton buttonText={"mph"} onClick={setImperialSystem}></ContentButton>
                </div>
                <section className="leaderboards">
                    {tracks.map((track, trackId) => (
                        
                        <div className="leaderboard-object" key={trackId}>
                        
                        <WhiteSpace height="50"/>
                            <div >
                                <div className="track-header">{track.name}</div>
                                 <div>
                                 <div className="grid-container">
                                                    <div className="grid-position grid-element info">
                                                    🥇
                                                    </div>
                                                    <div className="grid-element info">
                                                        Driver
                                                    </div>
                                                    <div className="grid-element info">
                                                        Time
                                                    </div>
                                                    <div className="grid-element info">
                                                        Vehicle
                                                    </div>
                                                    <div className="grid-element info">
                                                        Max Speed
                                                    </div>
                                                   
                                                </div>
                                    {/* Filter and sort times by timer_value */}
                                    {times
                                        .filter((trackTime) => trackTime.track_id === track.index) // Filter by track_id
                                        .sort((a, b) => a.timer_value - b.timer_value) // Sort by timer_value
                                        .map((trackTime, trackTimeId) => (
                                         
                                                <div className="grid-container">
                                                    <div className="grid-position grid-element">
                                                        

                                                        {trackTime.flagged ? 
                                                        <div className="flagged-time" onClick={toggleBox}>
                                                            <div>⚠</div>
                                                            <div className="flagged-time-text">FLAGGED TIME</div> 
                                                        </div>
                                                        :  
                                                        <div>{trackTimeId+1}</div>
                                                        }

                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.user_name} <span className="hash-id">#{trackTime.user_id}</span>
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.display_timer}
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.car_name}
                                                    </div>
                                                    <div className="grid-element">
                                                        {convertSpecificToImperial(trackTime.max_speed)} {speedString}
                                                    </div>
                                                    
                                                </div>
                                          
                                        ))}
                                </div>
                            </div>

                        </div>
                    ))}
                </section>
            </section>
        </div>
        <Footer/>
    </div>
    );
};

export default BR5ALeaderboards;